<template>
  <div class="user-profile-container">
    <div class="profile-layout">
      <!-- 左侧导航栏 -->
      <div class="profile-sidebar">
        <el-menu
            :default-active="activeMenu"
            class="profile-menu"
            router
        >
          <el-menu-item index="/profile/UserProfileMain">
            <el-icon><User /></el-icon>
            <span>个人中心</span>
          </el-menu-item>

          <el-menu-item index="/profile/UserProfilePlugins">
            <el-icon><Link /></el-icon>
            <span>插件管理</span>
          </el-menu-item>

          <el-menu-item index="/profile/UserProfileOrders">
            <el-icon><List /></el-icon>
            <span>订单管理</span>
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 右侧内容区域 -->
      <div class="profile-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, watch, computed, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'

const route = useRoute()
const router = useRouter()

// 设置默认激活菜单为个人中心
const activeMenu = ref('/profile/UserProfileMain')

// 监听路由变化，设置激活菜单
watch(() => route.path, (newPath) => {
  activeMenu.value = newPath

  // 如果直接访问 /profile，重定向到个人中心
  if (newPath === '/profile') {
    router.replace('/profile/UserProfileMain')
  }
}, {immediate: true})

// 组件挂载时检查是否需要重定向
onMounted(() => {
  if (route.path === '/profile') {
    router.replace('/profile/UserProfileMain')
  }
})
</script>

<style scoped>
.user-profile-container {
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
  padding: 20px;
}

.profile-layout {
  display: flex;
  min-height: 750px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-sidebar {
  width: 180px;
  background: linear-gradient(90deg, #fefdfd 0%, #f8fafe 100%);
  border-right: 1px solid #eaeef2;
}

.profile-menu {
  border-right: none;
  background: transparent;
}

.profile-menu :deep(.el-menu-item) {
  height: 40px;
  line-height: 40px;
  margin: 5px 0;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  border-left: 3px solid transparent;
}

.profile-menu :deep(.el-menu-item:hover) {
  background-color: transparent;
  color: #409eff;
}

.profile-menu :deep(.el-menu-item.is-active) {
  background-color: #ecf5ff;
  color: #409eff;
  font-weight: 500;
  border-left: 3px solid #409eff;
}

.profile-menu ::v-deep(.el-menu-item) .el-icon {
  color: #909399;
  font-size: 18px;
  margin-right: 10px;
}

.profile-menu :deep(.el-menu-item:hover) .el-icon {
  color: #409eff;
}

.profile-menu :deep(.el-menu-item.is-active) .el-icon {
  color: #409eff;
}

.profile-content {
  flex: 1;
  padding: 20px;
  background: transparent;
  min-height: 600px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-profile-container {
    padding: 10px;
  }

  .profile-layout {
    flex-direction: column;
    min-height: auto;
  }

  .profile-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #eaeef2;
  }

  .profile-menu {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px;
  }

  .profile-menu :deep(.el-menu-item) {
    margin: 4px;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    min-width: auto;
    flex: 1;
    text-align: center;
    border-radius: 20px;
  }

  .profile-menu :deep(.el-menu-item.is-active) {
    border-right: none;
    border-bottom: 2px solid #409eff;
  }
}
</style>